export default {
  rules: {
    required: 'この項目は必須です',
    email: '有効なメールアドレスを入力してください',
    url: '有効なURLを入力してください',
    alpha: '文字のみ使用可能です',
    alphaNum: '文字と数字のみ使用可能です',
    numeric: '数字のみ使用可能です',
    min: '{min}以上である必要があります',
    max: '{max}以下である必要があります',
    minLength: '{min}文字以上である必要があります',
    maxLength: '{max}文字以下である必要があります',
    between: '{min}から{max}の間である必要があります',
    confirmed: '入力が一致しません',
    date: '有効な日付を入力してください',
    dateFormat: '日付は{format}形式である必要があります',
    dateAfter: '{date}以降の日付である必要があります',
    dateBefore: '{date}以前の日付である必要があります'
  },
  fields: {
    name: '名前',
    email: 'メールアドレス',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    message: 'メッセージ',
    phone: '電話番号',
    subject: '件名',
    comments: 'コメント',
    feedback: 'フィードバック'
  }
}; 